import React from 'react';

import GooglePlay from '../../assets/images/google_play.png';
import AppStore from '../../assets/images/appstore.png';

import Image1 from '../../assets/images/app_screen_2.png';
import Image2 from '../../assets/images/app_screen_3.png';
import Image3 from '../../assets/images/app_screen_4.png';

import './ready.scss';

import {GP_URL, AP_URL} from '../config';

const Ready = () => {
    return (
        <section className="ready">
            <div className="container">
                <div className="row">
                    <img src={Image1} className="ready__image1" alt="" data-aos="fade-up" data-aos-delay="300"/>
                    <img src={Image2} className="ready__image2" alt="" data-aos="fade-up" data-aos-delay="150" />
                    <img src={Image3} className="ready__image3" alt="" data-aos="fade-up" />
                    <div className="col-6">
                        <p className="g-h2" data-aos="fade-up">Gotowy?</p>
                        <p className="g-desc" data-aos="fade-up" data-aos-delay="150">Dołącz do naszej społeczności i&nbsp;korzystaj z&nbsp;aplikacji w&nbsp;walce o&nbsp;lepsze zdrowie! Nie pozwól pokonać się chorobie!</p>
                        <a href={AP_URL} rel="noreferrer" target="_blank" className="appstore"><img src={AppStore} alt="Pobierz z App Store"  data-aos="fade-up" data-aos-delay="250"/></a>
                        <a href={GP_URL} rel="noreferrer" target="_blank" className="googleplay"><img src={GooglePlay} alt="Pobierz z Google Play"  data-aos="fade-up" data-aos-delay="200"/></a>
                        <div data-aos="fade-up" data-aos-delay="150">
                            <p className="ready__desc">W razie jakichkolwiek pytań lub sugestii pisz na:</p>
                            <a href="mailto:mukoapp@pcfs.pl" className="ready__link">mukoapp@pcfs.pl</a>
                            <p className="ready__desc">Więcej informacji na temat mukowiscydozy na:</p>
                            <a href="https://pcfs.pl" rel="noreferrer" target="_blank" className="ready__link">pcfs.pl</a>
                        </div>
                    </div>
                    <div className="col-12">
                        <p class="ready__stores">Apple, the Apple logo are trademarks of Apple Inc., registered in the United States and other countries.<br/>
                        Google Play and the Google Play logo are trademarks of Google LLC.</p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Ready;